export default __webpack_public_path__ + "static/coorporate_2-06c5510c9af46782ea7a37850e6a3b99.png";